module.exports = __webpack_public_path__ + "static/img/6.70859d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/eng/6.png
// module id = hS/p
// module chunks = 0